/**
 * Utility function to merge className strings
 * Useful for conditional classes and component composition
 *
 * @param {...(string|undefined|null|boolean)} classes - Class names to merge
 * @returns {string} Merged class name string
 *
 * @example
 * cn('base-class', condition && 'conditional-class', 'another-class')
 * // => 'base-class conditional-class another-class' (if condition is true)
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default cn;
